module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modalwords",
    attrs: {
      "id": "modalwords",
      "title": "C'est parti !",
      "ok-title": _vm.gameMode === 'boardCreation' ? 'Créer le plateau' : 'Ok, c\'est parti',
      "cancel-title": "Une autre carte"
    },
    on: {
      "cancel": _vm.shuffleWords,
      "ok": _vm.playMainboard
    }
  }, [_vm._l((_vm.words), function(wordtype, variant, index) {
    return (_vm.words.danger.length > 0 && _vm.words.warning.length > 0 && _vm.words.success.length > 0) ? _c('section', {
      key: index
    }, _vm._l((wordtype[0].fields), function(definition, key, index_w) {
      return _c('div', {
        key: index_w,
        staticClass: "mb-3",
        class: [_vm.isActive(definition) ? 'active' : 'word-card', 'alert-' + variant],
        on: {
          "click": function($event) {
            return _vm.pushWord(definition, variant)
          }
        }
      }, [_vm._v("\n        " + _vm._s(definition) + "\n    ")])
    }), 0) : _vm._e()
  }), _vm._v(" "), _c('p', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "text-secondary",
    attrs: {
      "href": "https://jrmie818423.typeform.com/to/Kf9Ux6",
      "target": "_blank"
    }
  }, [_vm._v(">> Proposer des mots ou expressions")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d8d18a0","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal-words.vue
// module id = V539
// module chunks = 1